/* index.tsx generated by @compiled/babel-plugin v2.0.0 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXI5zaO%7Bmin-width%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3138421Y8M%7Bmargin-top%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0adFHs8HPE%7Bmargin-right%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1EqgXl5zaO%7Bmax-width%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2sNsIg7NXe%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzy7kJ%7Bcolor%3Avar(--ds-text%2C%23292a2e)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39HuIbz8Lp%7Btext-overflow%3Aellipsis%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzZpcK%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYz9r67%7Bcolor%3Avar(--ds-border%2C%230b120e24)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._313842dnbC%7Bmargin-top%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0adFHsdnbC%7Bmargin-right%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1DCdHidnbC%7Bmargin-bottom%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2XsHFMdnbC%7Bmargin-left%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r22ADO%7Bpadding-top%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wydGW2ADO%7Bpadding-bottom%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Zuz6QsIZQ%7Bpadding-left%3Aclamp(var(--ds-space-100%2C8px)%2Cvar(--link-picker-padding-left)%2C100%25)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ZnuxbasAi%7Bpadding-right%3Aclamp(var(--ds-space-100%2C8px)%2Cvar(--link-picker-padding-right)%2C100%25)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0wOv4Q7zJH%7Bcursor%3Apointer%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1eOmH6o126%3Ahover%7Bbackground-color%3Avar(--ds-background-neutral-subtle-hovered%2C%230515240f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3fSdSTsKwa%3Ahover%7Bbox-shadow%3Ainset%202px%200%200%20var(--ds-border-selected%2C%231868db)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXruY9q9%7Bbackground-color%3Avar(--ds-background-selected%2C%23e9f2fe)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2OUyjtsKwa%7Bbox-shadow%3Ainset%202px%200%200%20var(--ds-border-selected%2C%231868db)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1zr6Dc98eZ%3Afocus%7Boutline-color%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0htemXYbGa%3Afocus%7Boutline-style%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._067LceT6kp%3Afocus%7Boutline-width%3Amedium%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._32C2rk98eZ%3Afocus%7Btext-decoration-color%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0i9AWAYbGa%3Afocus%7Btext-decoration-line%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0mm6KQ6wH8%3Afocus%7Btext-decoration-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0ui43Codfs%3Afocus%7Bbox-shadow%3A0%200%200%202px%20var(--ds-border-focused%2C%234688ec)%20inset%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0GwItXDIqT%7Balign-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
import { forwardRef, Fragment, type ForwardRefExoticComponent, type KeyboardEvent, type RefAttributes } from 'react';
import { type IntlShape, useIntl } from 'react-intl';
import { Text } from '@atlaskit/primitives/compiled';
import { type LinkSearchListItemData } from '../../../../../common/types';
/* eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports */
import { transformTimeStamp } from '../../../transformTimeStamp';
export const testIds = {
  searchResultItem: 'link-search-list-item',
  searchResultIcon: 'link-search-list-item-icon'
};
const isSVG = (icon: string) => icon.startsWith('<svg') && icon.endsWith('</svg>');
const base64SVG = (icon: string) => `data:image/svg+xml;base64,${Buffer.from(icon).toString('base64')}`;
const itemIconStyles = null;
const listItemContextStyles = null;
const listItemContainerStyles = null;
const listItemContainerInnerStylesA11yRefresh = null;
const listItemContainerInnerStylesSeparatorLinkPickerRefresh = null;
const itemNameStyles = null;
const imgStyles = null;
const listItemBaseStyles = null;
const ListItemIcon = (props: {
  item: LinkSearchListItemData;
  intl: IntlShape;
}) => {
  const {
    item,
    intl
  } = props;
  const {
    icon,
    iconAlt
  } = item;
  if (!icon) {
    return null;
  }
  const alt = typeof iconAlt === 'string' ? iconAlt : intl.formatMessage(iconAlt);
  if (typeof icon !== 'string') {
    const Glyph = icon;
    return <span className={ax(["_4ouGXI5zaO _3138421Y8M _0adFHs8HPE"])}>
				<Glyph alt={alt} data-testid={testIds.searchResultIcon} />
			</span>;
  }
  return <span className={ax(["_4ouGXI5zaO _3138421Y8M _0adFHs8HPE"])}>
			<img data-testid={testIds.searchResultIcon} src={isSVG(icon) ? base64SVG(icon) : icon} alt={alt} className={ax(["_1EqgXl5zaO"])} />
		</span>;
};
type SubtitleProps = {
  items: NonNullable<LinkSearchListItemData['subtitleItems']>;
};
const ListItemSubtitle = ({
  items: [firstItem, secondItem]
}: SubtitleProps) => {
  return <div data-testid={`${testIds.searchResultItem}-subtitle`} className={ax(["_2sNsIg7NXe _1UtDYzy7kJ _3iDTPbQ4SZ"])}>
			<div className={ax(["_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp"])}>
				<span className={ax(["_1UtDYzZpcK _1ANEUSLRg7"])}>{firstItem}</span>
			</div>
			{secondItem && <div className={ax(["_1UtDYzZpcK _1ANEUSLRg7"])}>
					<span className={ax(["_1UtDYz9r67"])}>
						<Fragment>&nbsp; •&nbsp; </Fragment>
					</span>
					<Fragment>{secondItem}</Fragment>
				</div>}
		</div>;
};
const getDefaultSubtitleItems = (item: LinkSearchListItemData, intl: IntlShape): LinkSearchListItemData['subtitleItems'] => {
  const container = item.container;
  const date = transformTimeStamp(intl, item.lastViewedDate, item.lastUpdatedDate);
  if (container) {
    if (date) {
      return [container, date];
    }
    return [container];
  }
  if (date) {
    return [date];
  }
  return undefined;
};
export type LinkSearchListItemProps = {
  item: LinkSearchListItemData;
  selected: boolean;
  active: boolean;
  tabIndex?: number;
  onSelect: (objectId: string) => void;
  onKeyDown: (e: KeyboardEvent<HTMLDivElement>) => void;
  onFocus: () => void;
  id?: string;
  role?: string;
  nameMaxLines?: number;
};
const listItemActive = null;
const listItemSelected = null;
const listItemFocusStyles = null;
export const LinkSearchListItem: ForwardRefExoticComponent<LinkSearchListItemProps & RefAttributes<HTMLDivElement>> = forwardRef<HTMLDivElement, LinkSearchListItemProps>(({
  item,
  selected,
  id,
  onSelect,
  tabIndex,
  onKeyDown,
  onFocus,
  nameMaxLines = 1
}: LinkSearchListItemProps, ref): JSX.Element => {
  const intl = useIntl();
  const handleSelect = () => onSelect(item.objectId);
  const subtitleItems = item.subtitleItems || getDefaultSubtitleItems(item, intl);
  return <div role="option" id={id} aria-selected={selected} data-testid={testIds.searchResultItem} onKeyDown={onKeyDown} onClick={handleSelect} onFocus={onFocus} tabIndex={tabIndex} ref={ref} className={ax(["_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _3iDTPbQ4SZ _0Of8r22ADO _1wydGW2ADO _2Zuz6QsIZQ _1ZnuxbasAi _0wOv4Q7zJH", !selected && "_1eOmH6o126 _3fSdSTsKwa", selected && "_0KLXruY9q9 _2OUyjtsKwa", "_1zr6Dc98eZ _0htemXYbGa _067LceT6kp _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _0ui43Codfs"])}>
				<ListItemIcon item={item} intl={intl} />
				<div className={ax(["_4bt5LAnQyn _2WAcuGnQyn _0GwItXDIqT _39xV02N91d"])}>
					<Text maxLines={nameMaxLines}>
						<span data-testid={`${testIds.searchResultItem}-title`} title={item.name}>
							{item.name}
						</span>
					</Text>
					{subtitleItems && <ListItemSubtitle items={subtitleItems} />}
				</div>
			</div>;
});